import React from 'react';
import { Grid } from '@material-ui/core';
import CustomLabel from 'src/pages/reportUsage/common/customLabel/CustomLabel.jsx';
import { StyledTextDiv } from '../../../../reportUsage/utils/reportUsage.styled';
import AlertMsg from '../AlertMsg';
import { useTranslation } from 'react-i18next';
import { TextWithInputsContainer } from './TextWithInputs.styled';

const TextWithInputs = ({
    xs,
    styleObj,
    value,
    onkeyUp,
    name,
    topLabel,
    bottomLabel,
    width,
    paddingLeft,
    placeholder,
    lg,
    cursor,
    md,
    sm,
    onLabelClick,
    maxLength,
    inputWidth,
    inputHeight,
    inputDisabled,
    defaultValue,
    alignText,
    isBundleItem,
    errorMsg,
    fSize,
    textAlign,
    paddingRight,
    autoFocus,
    background,
    marginBottom,
    backgroundInactive,
    colorDisabled,
    borderRadius,
    marginTop,
}) => {
    const { t } = useTranslation();
    return (
        <Grid item xs={xs} lg={lg} md={md} sm={sm} style={styleObj}>
            <TextWithInputsContainer
                width={width}
                paddingLeft={paddingLeft}
                paddingRight={paddingRight}
                textAlign={textAlign}
                marginTop={marginTop}
            >
                {topLabel && (
                    <CustomLabel
                        fSize={'12px!important'}
                        color="#140F4B"
                        opacity="70%"
                        label={topLabel}
                        textAlign={alignText}
                        marginBottom={'8px !important'}
                    />
                )}
                {isBundleItem ? (
                    <StyledTextDiv
                        opacity={1}
                        fontFamily="AvenirNextWorld Regular"
                        color="#202124"
                        fontSize={'15px'}
                        padding={'10px 0 0'}
                    >
                        {t('reportUsage.common.textWithInputs.notApplicable')}
                    </StyledTextDiv>
                ) : (
                    <>
                        <input
                            className={/account|billTo|patient|physician|contact|phone|email|fax|poNumber|notes/i.test(name || '') ? `consignment-billing-${name}-dt-mask` : undefined}
                            placeholder={placeholder}
                            disabled={inputDisabled}
                            onBlur={!maxLength ? onkeyUp : undefined}
                            onChange={maxLength ? onkeyUp : undefined}
                            name={name}
                            value={value}
                            style={{
                                width: inputWidth ? inputWidth : '100%',
                                height: inputHeight,
                                border: '1px solid #ced4da',
                                padding: '6px 8px',
                                borderRadius: borderRadius
                                    ? borderRadius
                                    : '3px',
                                outline: 'none',
                                background: inputDisabled
                                    ? background
                                        ? background
                                        : '#EBEBEB 0% 0% no-repeat padding-box'
                                    : '#FFFFFF 0% 0% no-repeat padding-box',

                                color: colorDisabled
                                    ? colorDisabled
                                    : '#202124',
                                opacity: 1,
                                fontFamily: 'AvenirNextWorld Regular',
                                textAlign: alignText,
                                fontSize: fSize,
                            }}
                            maxLength={maxLength}
                            defaultValue={defaultValue}
                            autoComplete="off"
                            autoFocus={autoFocus === 'on'}
                        />
                        {errorMsg && (
                            <div
                                style={{
                                    display: 'flex',
                                    width: 'max-content',
                                    paddingTop: '7px',
                                }}
                            >
                                <AlertMsg message={errorMsg} />
                            </div>
                        )}
                    </>
                )}
                {bottomLabel && (
                    <CustomLabel
                        fSize={'12px!important'}
                        color="#1010EB"
                        cursor={cursor}
                        opacity={1}
                        label={bottomLabel}
                        onLabelClick={onLabelClick}
                        paddingTop={'10px'}
                        letterSpacing={'-0.11px'}
                    />
                )}
            </TextWithInputsContainer>
        </Grid>
    );
};

export default TextWithInputs;
